import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import './LegalPages.css';

export default function Impressum() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('de');

  useEffect(() => {
    // Get language from localStorage (user preference) or browser
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setLanguage(user.language || 'de');
      } catch (e) {
        setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
      }
    } else {
      setLanguage(navigator.language.startsWith('de') ? 'de' : 'en');
    }
  }, []);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
        >
          ← {language === 'de' ? 'Zurück' : 'Back'}
        </Button>
        <Button 
          variant="outline" 
          onClick={toggleLanguage}
          className="language-toggle"
        >
          {language === 'de' ? '🇬🇧 English' : '🇩🇪 Deutsch'}
        </Button>
      </div>

      <div className="legal-content">
        {language === 'de' ? (
          <>
            <h1>Impressum</h1>
            <p className="last-updated">Angaben gemäß § 5 TMG</p>

        <section>
          <h2>Anbieter</h2>
          <p>
            <strong>Storytales - Create magical personalized stories for children</strong><br />
            Betreiber: Alex Mickel<br />
            Am Neuberg 20<br />
            67593 Westhofen<br />
            Deutschland
          </p>
        </section>

        <section>
          <h2>Kontakt</h2>
          <p>
            E-Mail: info@storytales.xyz
          </p>
        </section>

        <section>
          <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            Nicht vorhanden (Kleinunternehmerregelung)
          </p>
        </section>

        <section>
          <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p>
            Alex Mickel<br />
            Am Neuberg 20<br />
            67593 Westhofen
          </p>
        </section>

        <section>
          <h2>EU-Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr/
            </a><br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </section>

        <section>
          <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <section>
          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
            Tätigkeit hinweisen.
          </p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
            allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
            erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend 
            entfernen.
          </p>
        </section>

        <section>
          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
            Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
            mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
            Verlinkung nicht erkennbar.
          </p>
        </section>

        <section>
          <h2>Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
            der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
            Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
            nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p>
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
            Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
            gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
            bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
            werden wir derartige Inhalte umgehend entfernen.
          </p>
        </section>

        <section>
          <h2>KI-generierte Inhalte und Haftungsausschluss</h2>
          <p>
            <strong>Künstliche Intelligenz im Einsatz:</strong>
          </p>
          <p>
            StoryTales nutzt künstliche Intelligenz (KI) zur Generierung von personalisierten 
            Kindergeschichten. Sowohl die Geschichtentexte als auch die Illustrationen werden 
            vollständig durch KI-Systeme erstellt:
          </p>
          <ul>
            <li><strong>Texte:</strong> Generiert durch Google Gemini 2.5 Pro</li>
            <li><strong>Illustrationen:</strong> Generiert durch OpenAI DALL-E 3 und Google Nano Banana</li>
          </ul>
          <p>
            <strong>Haftungsausschluss für KI-generierte Inhalte:</strong>
          </p>
          <p>
            Wir übernehmen keine Gewähr für die inhaltliche Richtigkeit, Vollständigkeit, 
            Genauigkeit oder pädagogische Eignung der KI-generierten Geschichten und Illustrationen. 
            KI-Systeme können:
          </p>
          <ul>
            <li>Faktisch falsche oder irreführende Informationen erzeugen ("Halluzinationen")</li>
            <li>Unangemessene, unbeabsichtigte oder kulturell unpassende Inhalte generieren</li>
            <li>Unvorhersehbare oder inkonsistente Ergebnisse liefern</li>
            <li>Stereotype oder voreingenommene Darstellungen reproduzieren</li>
          </ul>
          <p>
            <strong>Elterliche Aufsichtspflicht:</strong>
          </p>
          <p>
            Eltern und Erziehungsberechtigte sind ausdrücklich angehalten, alle generierten 
            Geschichten VOR dem Vorlesen an Kinder zu überprüfen. Die Nutzung der Plattform 
            ersetzt nicht die elterliche Kontrolle und Verantwortung für altersgerechte Inhalte.
          </p>
          <p>
            <strong>Keine Haftung für:</strong>
          </p>
          <ul>
            <li>Sachliche Unrichtigkeiten in den Geschichtentexten</li>
            <li>Psychologische oder pädagogische Auswirkungen der Inhalte</li>
            <li>Urheberrechtsverletzungen durch KI-generierte Inhalte</li>
            <li>Kulturelle Sensibilitäten oder Darstellungen</li>
            <li>Emotionale Reaktionen von Kindern auf die Inhalte</li>
          </ul>
        </section>

        <section>
          <h2>Inhaltsmoderation und Nutzerpflichten</h2>
          <p>
            Wir setzen grundlegende automatisierte Moderationssysteme ein, um unangemessene 
            Inhalte zu verhindern. Eine 100%ige Filterung problematischer Inhalte kann jedoch 
            technisch nicht garantiert werden.
          </p>
          <p>
            Nutzer werden gebeten, unangemessene oder problematische Inhalte unverzüglich über 
            info@storytales.xyz zu melden.
          </p>
        </section>

        <section>
          <h2>Urheberrecht und Nutzungsrechte an KI-Inhalten</h2>
          <p>
            Die Rechte an KI-generierten Inhalten unterliegen den Nutzungsbedingungen der 
            jeweiligen KI-Anbieter (OpenAI, Google). Die Nutzer erhalten ein einfaches, 
            nicht-exklusives Nutzungsrecht für den privaten, nicht-kommerziellen Gebrauch.
          </p>
          <p>
            <strong>Wichtiger Hinweis:</strong> Die rechtliche Lage bezüglich Urheberrechten 
            an KI-generierten Werken ist in vielen Rechtsordnungen noch nicht abschließend 
            geklärt. Wir übernehmen keine Gewähr für die urheberrechtliche Schutzfähigkeit 
            der generierten Inhalte.
          </p>
          <p>
            Eine kommerzielle Nutzung der generierten Geschichten erfolgt auf eigenes Risiko 
            des Nutzers und bedarf unserer vorherigen schriftlichen Zustimmung.
          </p>
        </section>
          </>
        ) : (
          <>
            <h1>Legal Notice (Impressum)</h1>
            <p className="last-updated">Information according to § 5 TMG (German Telemedia Act)</p>

            <section>
              <h2>Provider</h2>
              <p>
                <strong>Storytales - Create magical personalized stories for children</strong><br />
                Operator: Alex Mickel<br />
                Am Neuberg 20<br />
                67593 Westhofen<br />
                Germany
              </p>
            </section>

            <section>
              <h2>Contact</h2>
              <p>
                Email: info@storytales.xyz
              </p>
            </section>

            <section>
              <h2>VAT ID</h2>
              <p>
                Value added tax identification number according to § 27 a of the German Value Added Tax Act:<br />
                Not applicable (small business regulation)
              </p>
            </section>

            <section>
              <h2>Responsible for Content according to § 55 Para. 2 RStV</h2>
              <p>
                Alex Mickel<br />
                Am Neuberg 20<br />
                67593 Westhofen
              </p>
            </section>

            <section>
              <h2>EU Dispute Resolution</h2>
              <p>
                The European Commission provides a platform for online dispute resolution (ODR): 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                  https://ec.europa.eu/consumers/odr/
                </a><br />
                You can find our email address in the contact section above.
              </p>
            </section>

            <section>
              <h2>Consumer Dispute Resolution / Universal Arbitration Board</h2>
              <p>
                We are not willing or obliged to participate in dispute resolution proceedings 
                before a consumer arbitration board.
              </p>
            </section>

            <section>
              <h2>Liability for Content</h2>
              <p>
                As a service provider, we are responsible for our own content on these pages in 
                accordance with § 7 Para. 1 TMG (German Telemedia Act) under general law. However, 
                according to §§ 8 to 10 TMG, we are not obligated to monitor transmitted or stored 
                third-party information or to investigate circumstances that indicate illegal activity.
              </p>
              <p>
                Obligations to remove or block the use of information under general law remain 
                unaffected. However, liability in this regard is only possible from the point in 
                time at which knowledge of a specific infringement of the law is obtained. If we 
                become aware of such violations, we will remove this content immediately.
              </p>
            </section>

            <section>
              <h2>Liability for Links</h2>
              <p>
                Our website contains links to external third-party websites over whose content we 
                have no influence. Therefore, we cannot assume any liability for this external 
                content. The respective provider or operator of the pages is always responsible 
                for the content of the linked pages.
              </p>
            </section>

            <section>
              <h2>Copyright</h2>
              <p>
                The content and works created by the site operators on these pages are subject to 
                German copyright law. Duplication, processing, distribution and any kind of 
                exploitation outside the limits of copyright require the written consent of the 
                respective author or creator.
              </p>
              <p>
                Insofar as the content on this site was not created by the operator, the copyrights 
                of third parties are respected. Third-party content is marked as such. Should you 
                nevertheless become aware of a copyright infringement, please inform us accordingly. 
                If we become aware of any infringements, we will remove such content immediately.
              </p>
            </section>

            <section>
              <h2>AI-Generated Content and Disclaimer</h2>
              <p>
                <strong>Artificial Intelligence in Use:</strong>
              </p>
              <p>
                StoryTales uses artificial intelligence (AI) to generate personalized children's 
                stories. Both the story texts and illustrations are created entirely by AI systems:
              </p>
              <ul>
                <li><strong>Texts:</strong> Generated by Google Gemini 2.5 Pro</li>
                <li><strong>Illustrations:</strong> Generated by OpenAI DALL-E 3 and Google Nano Banana</li>
              </ul>
              <p>
                <strong>Disclaimer for AI-Generated Content:</strong>
              </p>
              <p>
                We do not guarantee the accuracy, completeness, correctness, or pedagogical 
                suitability of AI-generated stories and illustrations. AI systems may:
              </p>
              <ul>
                <li>Produce factually incorrect or misleading information ("hallucinations")</li>
                <li>Generate inappropriate, unintended, or culturally insensitive content</li>
                <li>Deliver unpredictable or inconsistent results</li>
                <li>Reproduce stereotypes or biased representations</li>
              </ul>
              <p>
                <strong>Parental Supervision Required:</strong>
              </p>
              <p>
                Parents and guardians are expressly advised to review all generated stories 
                BEFORE reading them to children. Using the platform does not replace parental 
                control and responsibility for age-appropriate content.
              </p>
              <p>
                <strong>No Liability For:</strong>
              </p>
              <ul>
                <li>Factual inaccuracies in story texts</li>
                <li>Psychological or pedagogical effects of the content</li>
                <li>Copyright infringements by AI-generated content</li>
                <li>Cultural sensitivities or representations</li>
                <li>Emotional reactions of children to the content</li>
              </ul>
            </section>

            <section>
              <h2>Content Moderation and User Responsibilities</h2>
              <p>
                We employ basic automated moderation systems to prevent inappropriate content. 
                However, 100% filtering of problematic content cannot be technically guaranteed.
              </p>
              <p>
                Users are requested to immediately report inappropriate or problematic content 
                via info@storytales.xyz.
              </p>
            </section>

            <section>
              <h2>Copyright and Usage Rights for AI Content</h2>
              <p>
                Rights to AI-generated content are subject to the terms of use of the respective 
                AI providers (OpenAI, Google). Users receive a simple, non-exclusive usage right 
                for private, non-commercial use.
              </p>
              <p>
                <strong>Important Notice:</strong> The legal situation regarding copyrights for 
                AI-generated works is not yet conclusively clarified in many jurisdictions. We 
                do not guarantee the copyright protection eligibility of the generated content.
              </p>
              <p>
                Commercial use of the generated stories is at the user's own risk and requires 
                our prior written consent.
              </p>
            </section>
          </>
        )}
      </div>
    </div>
  );
}
